import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    switchList: [],
    batchSwitchList: [],
    serviceChargeList: [],
    querySwitchType: 0, //0表示批量开关，1表示撤销订单开关
    coinList: ['ETH'] //需要设置手续费的币种
  },
  getters: {},
  mutations: {
    setSwitchList(state, payload) {
      state.switchList = payload;
    },
    setBatchSwitchList(state, payload) {
      state.batchSwitchList = payload;
    },
    setServiceChargeList(state, payload) {
      state.serviceChargeList = payload;
    },
    setQuerySwitchType(state, payload) {
      state.querySwitchType = payload;
    }
  },
  actions: {
    list({ commit }, coin) {
      api.getSwitchList(coin).then(({ data }) => {
        commit('setSwitchList', data);
      });
    },
    updateSwitchStatus(context, data) {
      return api.updateSwitchStatus(data);
    },
    updateBatchWithdrawSize(context, data) {
      return api.updateBatchWithdrawSize(data);
    },
    updateGasPrice(context, data) {
      return api.updateGasPrice(data);
    },
    updateToColdGasPrice(context, data) {
      return api.updateToColdGasPrice(data);
    },
    updateGasLimitChange(context, data) {
      return api.updateGasLimitChange(data);
    },
    updateToColdGasLimitChange(context, data) {
      return api.updateToColdGasLimitChange(data);
    },

    batchList({ commit }) {
      api.getBatchSwitchList().then(({ data }) => {
        commit('setBatchSwitchList', data);
      });
    },
    updateBatchSwitchStatus(context, data) {
      return api.updateBatchSwitchStatus(data);
    },
    updateJobBatchSize(context, data) {
      return api.updateJobBatchSize(data);
    },
    deleteBatchJob(context, data) {
      return api.deleteBatchJob(data);
    },

    /** 通过币种获取开关配置信息 */
    getSwitchConfigInfoByCoinType({ commit }, coinType) {
      return api.findSwitchConfigInfoByCoinType({ coinType: coinType });
    },

    /** 通过jobName 获取批量开关配置信息*/
    getBatchSwitchByJobName({ commit }, jobName) {
      return api.findBatchSwitchInfoByJobName({ jobName: jobName });
    },

    buildCancelTradeList({ commit }) {
      api.getCancelTradeList().then(({ data }) => {
        commit('setBatchSwitchList', data);
      });
    },

    buildQuerySwitchType({ commit }, value) {
      commit('setQuerySwitchType', value);
    },

    clearBatchSwitchList({ commit }) {
      commit('setBatchSwitchList', []);
    },

    getServiceChargeList({ commit }, coins) {
      api.getServiceChargeList(coins).then(({ data }) => {
        commit('setServiceChargeList', data);
      });
    },
    getSwitchInfoByCoinType({ commit }, coinType) {
      return api.getSwitchInfoByCoinType({ coinType: coinType });
    },
    editGasPrice(context, data) {
      return api.editGasPrice(data);
    },
    editToColdGasPrice(context, data) {
      return api.editToColdGasPrice(data);
    }
  }
};

appStore.registerModule('walletSwitchSetting', store);
